/**
 * @module  public/js/utils/linkBuilder.js
 * @summary Normalises URLs for in-app links.
 *
 * @description
 * Trims whitespace, removes leading './' or '/', and ensures a protocol so
 * external links like LinkedIn open correctly.
 *
 * ## Exports
 * - normaliseUrl(raw)
 *
 * @version 1.0.0
 * @since   2025-07-19
 */

export function normaliseUrl(raw) {
  if (!raw) return '#';
  raw = raw.trim().replace(/^[./]+/, '');
  if (!/^https?:\/\//i.test(raw)) raw = 'https://' + raw;
  return raw;
}
